import packageJson from '../../package.json';

export interface AppVersion {
  version: string;
  name: string;
  buildDate: string;
  environment: string;
  gitCommit?: string;
}

export const getAppVersion = (): AppVersion => {
  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
  
  return {
    // Set by scripts/build.js from the latest git tag; unset under npm start and in tests
    version: process.env.REACT_APP_VERSION || '0.0.0-dev',
    name: packageJson.name,
    buildDate: new Date().toISOString().split('T')[0],
    environment,
    gitCommit: process.env.REACT_APP_GIT_COMMIT || 'unknown'
  };
};

export const getVersionDisplay = (): string => {
  const version = getAppVersion();
  return `${version.name} v${version.version} (${version.environment})`;
};

export const getDetailedVersion = (): string => {
  const version = getAppVersion();
  let details = `${version.name} v${version.version}`;
  
  if (version.environment !== 'production') {
    details += ` (${version.environment})`;
  }
  
  if (version.gitCommit && version.gitCommit !== 'unknown') {
    details += ` - ${version.gitCommit}`;
  }
  
  return details;
};

export const getVersionWithCommit = (): { version: string; commit: string; buildDate: string } => {
  const version = getAppVersion();
  return {
    version: version.version,
    commit: version.gitCommit || 'unknown',
    buildDate: version.buildDate
  };
};
